var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-plyr',{ref:"plyr",attrs:{"options":_vm.playerOptions}},[_c('video',{attrs:{"id":'video-' + 1,"data-plyr-config":"{'autoplay': true}"}})])}
var staticRenderFns = []

export { render, staticRenderFns }